import { LokiDbProvider } from './../../providers/loki-db/loki-db';
import { NetworkConnectionProvider } from './../../providers/network-connection/network-connection';
import { Component, ViewChild, ElementRef, NgZone } from '@angular/core';
import { NavController, NavParams, InfiniteScroll, Content, AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { IonicPage } from 'ionic-angular';
import { FirebaseListObservable } from 'angularfire2/database';
import { FirebaseServiceProvider } from '../../providers/firebase-service/firebase-service';
import { Platform } from 'ionic-angular';
import { Keyboard } from '@ionic-native/keyboard';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/repeatWhen'
import 'rxjs/add/operator/delay';
//import 'rxjs/add/operator/delayWhen'

/**
 * Generated class for the FindPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
    selector: 'page-find',
    templateUrl: 'find.html',
})
export class FindPage {
    @ViewChild('infinite') infinite: InfiniteScroll;
    @ViewChild(Content) content: Content;
    @ViewChild('mySearchbar') mySearchbar;


    //stringa che indica il risultato della ricerca
    statusLabel: string = "";

    //var con il valore totale dei risultati
    resultLabel: string = "";
    query_result_length = 0;

    //valore inserito nella searchbar
    myInput: string;
    mySearchText: string

    //var for min character before search
    MIN_CHAR_FOR_SEARCH = 3;

    //var for max number of result visible
    MAX_NUMBER_VISIBLE_CONTACT = 20;

    //var for show favorite search when not searching
    notSearching = true;

    //vars for helpfulnumbers card
    helpfulNumbersTitleLabel: string;
    helpfulNumbersDescrLabel: string;
    helpfulNumbersColor: string;
    helpfulNumbersPictureUrl: string; 

    query_or = "$or";
    query_and = "$and";

    // dictionary of filter
    filtri = [];
    //query dinamica dei filtri
    query_filter = {};
    active_filter = [];


    //array delle ricerche preferite
    favorite_search_array = [];
    favorite_search_terms = [];

    items: FirebaseListObservable<any[]>;
    item: any;

    array_data: any[] = [];
    //array_data: FirebaseListObservable<any[]>;

    //elementi della pagina per modifica css durante la ricerca
    header_menu;
    contentPageElement;
    tabsPageElement;
    header_menu_heigth;
    hideElement = false;


    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public alertCtrl: AlertController,
        private translateService: TranslateService,
        public lokiDB: LokiDbProvider,
        public network: NetworkConnectionProvider,
        private platform: Platform,
        public keyboard: Keyboard,
        public element: ElementRef,
        private zone: NgZone
    ) {


        //this.header_menu = translateService.instant("LABEL_READY"); //traduzioni dal json

        //COSTRUISCO LA QUERY DA PASSARE ALLA FIND
        this.query_filter[this.query_and] = [];
        this.active_filter = [];
        
        //web - focus sul campo di ricerca
        if(this.platform.is('core')) {
            setTimeout(() => {
                this.mySearchbar.setFocus();
            },150);
        }

    }


    ionViewDidLoad() {

        //console.log("ION VIEW DID LOAD");

        //seleziono gli elementi da nascondere durante la ricerca, header + tabs + barra di ricerca da spostare
        //this.header_menu = document.querySelector('#myheader');
        //this.contentPageElement = document.querySelector('.content').querySelector('.scroll-content');
        //console.log(this.contentPageElement);
        //this.header_menu_heigth = String(this.contentPageElement.style.marginTop);
        //console.log("Altezza header:"+this.header_menu_heigth);
        this.tabsPageElement = document.querySelector(".tabbar");

        this.keyboard.onKeyboardShow().subscribe(a => {
            this.tabsPageElement.style.display = 'none';
            this.navCtrl.resize();
        });

        this.keyboard.onKeyboardHide().subscribe(a => {

            this.tabsPageElement.style.display = 'flex';
            this.navCtrl.resize();
        });

        this.platform.win().onkeypress = (ev) => {
            if (ev.keyCode == 13) {
                try {
                    let field: any = document.querySelector(".searchbar-input");
                    field.blur();
                } catch (e) { }
            }
        }
        
    }

    fixSize() {
        try {
            if (!this.platform.is("ios")) {
                this.navCtrl.resize();
            }
        } catch (e) { }
    }

    ionViewDidEnter() {
        this.fixSize();
        this.lokiDB.trackPage(this.constructor.name)
    }

    async ionViewWillEnter() {
        //carico le  ricerche preferite del'utente
        if (!this.lokiDB.allDataLoaded && !this.lokiDB.alreadyLoading) await this.lokiDB.getAllData();

        this.loadFavoriteSearch();
        this.loadHelpfulNumbers();
    }


    async Search($event) {
        /********
         * Effettuo una ricerca dopo tot millisec
         * il risultato da loki viene memorizzato sulla var array_data
         * nella view visualizzo array_data aggiornato
         * se mi restituisce false la ricerca elemento, visualizzo comunque l'array con un elemento vuoto
         * per un problema sul virtual scroll
         */
        //se il testo che inserisco è diverso dal precedente e non una sottostringa, resetto i filtri attivi
        //console.log("stringa da cercare " + this.lokiDB.last_searchstring + " in " + this.myInput)
        //console.log(this.myInput.indexOf(this.lokiDB.last_searchstring))

        if (this.myInput.indexOf(this.lokiDB.last_searchstring) == -1) {
            this.active_filter = [];
            this.query_filter[this.query_and] = [];
        }


        if (this.myInput.replace(/\*/g, "").length < this.MIN_CHAR_FOR_SEARCH) {
            this.zone.run(() => {
                this.statusLabel = ""; //this.translateService.instant("NEED_MIN_CHAR");
                this.notSearching = true;
            })
        } else {
            //lancia la ricerca dopo aver immesso l'input e ottieni il risultato
            this.mySearchText = this.myInput
            this.startSearch();
        }

    }

    /**
     * Metodo che carica all'avvio le proprie ricerche operative
     * dal db loki memorizzato
     */
    private loadFavoriteSearch() {
        /**
        * FAVORITI CREATI DALL'UTENTE, salvati su db loki e in localstorage
        * AL MOMENTO UN ESEMPIO GENERATO
        */
        //console.log("devo caricare le ricerche favorite...");
        //console.log(this.lokiDB);
        this.lokiDB.getConfig().repeatWhen(v => { return v.delay(100) })
            .subscribe((val) => {
                //console.log("checkconfig")
                if (val != null) {
                    this.zone.run(() => {
                        this.favorite_search_array = val["favouriteSearches"].searches;
                    });
                }
            }, (err) => {
                console.log(err)
            });

        //console.log("caricate ricerche favorite");
        //console.log(this.favorite_search_array);

    }

    private loadHelpfulNumbers(){
        
        //Card numeri utili - Recupero impostazioni  
        this.lokiDB.getConfig().repeatWhen(v => { return v.delay(100) })
            .subscribe((val) => {
                //console.log("checkconfig")
                this.helpfulNumbersTitleLabel = this.translateService.instant("HELPFUL_NUMBERS_TITLE");
                this.helpfulNumbersDescrLabel = this.translateService.instant("HELPFUL_NUMBERS_DESCR");
                this.helpfulNumbersColor = "#FFC200"; 
                this.helpfulNumbersPictureUrl = "";
                if (this.lokiDB.config && this.lokiDB.config.getConfigSettings && this.lokiDB.config.getConfigSettings.helpfulNumbers) {
                    let hn = this.lokiDB.config.getConfigSettings.helpfulNumbers;
                    this.helpfulNumbersTitleLabel = hn.title;
                    this.helpfulNumbersDescrLabel = hn.description;
                    this.helpfulNumbersPictureUrl = hn.picture;
                    this.helpfulNumbersColor =  hn.color;
                }   
        }, (err) => {
            console.log(err)
        });
    }

    private isInputInFavorite() {

        return (this.favorite_search_array.findIndex((x) => {
            return x.search && this.myInput
                && x.search.toLowerCase() == this.myInput.toLowerCase();
        }) >= 0)


    }

    /**
     * Metodo che esegue una ricerca preferita
     */
    favorite_search(s) {
        this.mySearchText = s;
        this.myInput = this.mySearchText;
        this.startSearch();

    }

    save_favorite_search() {
        if (this.myInput != '') {
            this.lokiDB.manageSearch(this.myInput, null).then(() => {
                this.loadFavoriteSearch();
            })
        }
    }


    /**
     * Metodo che elimina una ricerca dai preferiti
     */
    delete_favorite_search(id) {
        this.lokiDB.manageSearch(null, id).then(() => {
            this.loadFavoriteSearch();
        })

    }


    /**
     * Questo metodo inserisce al filtro selezionato la classe css che modifica lo stato visualizzato
     * per indicare che è selezionato
     * inoltre aggiunge\rimuove i filtri nell'array active filter
     * @param event pulsante che ha generato l'evento
     * @param filtro il filtro da togliere o inserire nel risultato
     */
    private activeFilter(event, filtro, remove: 'no') {

        //Agginga o rimozione filtro selzionato
        if (remove == 'no') {
            //Aggiungo
            this.active_filter.push({ campo: filtro.campo, valore: filtro.valore });
        } else {
            //Rimuovo 
            this.active_filter = this.active_filter
                .filter(function (element) {
                    return (element.valore != filtro.valore);
                });
        }

        //genero la query dei filtri in base ai filtri attivi
        this.query_filter[this.query_and] = this.active_filter.map((p) => {

            let filtro_con_piu_campi = p.campo.split("|");
            /**
             * Se trovo un filtro con | che indica piu campi in cui il valore e' uguale, 
             * dobbiamo separarli e inserirli in or nel filtro
             */
            if (filtro_con_piu_campi.length > 1) {
                let filtri_in_or = [];
                filtro_con_piu_campi.forEach(element => {
                    let obj2 = {};
                    obj2[element] = p.valore;
                    filtri_in_or.push(obj2);
                });
                //Ritorno l'array di filtri in ore
                return { $or: filtri_in_or }

            } else {
                //Ritorno un elemeto semplice
                return { [p.campo]: p.valore }
            }
        });

        //esegue la ricerca con i filtri applicati
        this.startSearch();

    }


    doInfinite(infiniteScroll) {

        if (this.array_data.length == this.lokiDB.risultati_query) {
            infiniteScroll.enable(false);
            infiniteScroll.complete();
        } else {
            setTimeout(() => {
                var start = this.array_data.length - 1;
                var end = start + this.MAX_NUMBER_VISIBLE_CONTACT
                this.array_data = this.lokiDB.risultati_query.slice(0, end);

                if (this.array_data.length == this.lokiDB.risultati_query) {
                    infiniteScroll.enable(false);
                }
                infiniteScroll.complete();
            }, 50);
        }
    }




    /**
     * Metodo privato che lancia una ricerca dopo il cambio di myInput
     * dovuto ad una selezione di filtri o ricerca preferita ecc
     */
    private async startSearch() {


        //variabile di controllo, durante la fase di ricerca viene disabilitata
        this.notSearching = false;

        /*
        console.log("===query filter====")
        console.log(this.query_filter)
        console.log("===active filter====")
        console.log(this.active_filter)
        console.log("===termini====")
        console.log(this.myInput)
        */
        //richiamo la funzione di ricerca con i filtri
        const esitoRicerca = await this.lokiDB.ricercaElemento(this.mySearchText, this.query_filter[this.query_and].length ? this.query_filter : null);

        this.query_result_length = this.lokiDB.risultati_query.length;
        this.array_data = this.lokiDB.risultati_query.slice(0, this.MAX_NUMBER_VISIBLE_CONTACT);

        if (esitoRicerca) {
            this.statusLabel = "";//svuoto la label dello status, uso il result label
            this.resultLabel = this.translateService.instant("RESULT_FIND");
            /*if (this.array_data.length == this.query_result_length)
                this.infinite.enable (false);*/
        } else {
            this.statusLabel = this.translateService.instant("NO_RESULT_QUERY_FIND");
        }


        /**
        * FILTRI DA GENERARE SULLA RISPOSTA RICEVUTA, 
        * si aggiungono a quelli già selezionati 
        * viene ritardato il loro generamento per avere subito la query di risposta
        */
        this.filtri = [];


        this.zone.run(() => {
            this.createFilterOnSearch();
        });


    }



    private createFilterOnSearch() {

        //console.log("creazione filtri di ricerca...");

        var results = this.lokiDB.risultati_query;

        var availableFilters = [];
        let stores = [];
        let identity = []
        let limit = 10

        if (!(this.lokiDB.config && this.lokiDB.config.getAvailableFilters))
            return


        if (this.lokiDB.config.getAvailableFilters.limit) {
            limit = this.lokiDB.config.getAvailableFilters.limit;
        }

        if (this.lokiDB.config.getAvailableFilters.stores) {
            stores = this.lokiDB.config.getAvailableFilters.stores
            stores = stores.concat(availableFilters);
        }

        if (this.lokiDB.config.getAvailableFilters.identity) {
            identity = this.lokiDB.config.getAvailableFilters.identity
            identity = identity.concat(availableFilters);
        }

        var values = {};

        for (var i = 0; i < results.length; i++) {
            if (results[i].code) {
                stores.forEach(function (k, idx) {
                    if (!(k in values))
                        values[k] = {}

                    if (results[i][k] != undefined) {
                        var currVal = results[i][k];
                        if (currVal in values[k]) {
                            values[k][currVal]["freq"] += (1 / results.length);
                        } else {
                            values[k][currVal] = {}
                            values[k][currVal]["freq"] = (1 / results.length);
                            values[k][currVal]["order"] = idx;
                        }
                    }
                });
            } else {
                identity.forEach(function (k, idx) {
                    if (!(k in values))
                        values[k] = {}

                    if (results[i][k] != undefined) {
                        var currVal = results[i][k];
                        if (currVal in values[k]) {
                            values[k][currVal]["freq"] += (1 / results.length);
                        } else {
                            values[k][currVal] = {}
                            values[k][currVal]["freq"] = (1 / results.length);
                            values[k][currVal]["order"] = idx;
                        }
                    }
                });

            }
        };

        //console.log(values);

        var tempArray = []
        var freq, order;
        for (var f in values) {
            for (var f2 in values[f]) {
                //cerchiamo i campi in un range di presenza nei risultati globali
                if (values[f][f2]) {
                    freq = Math.fround(values[f][f2].freq);
                    order = values[f][f2].order
                    if (f2 != "" && freq != 1) {
                        tempArray.push({ campo: f, valore: f2, freq: freq, order: order });
                    }
                }
            }
        }
        //Ordinamento per rate crescente
        /*
        tempArray.sort(function (a, b) {
            return a.rate - b.rate;
        });
        */


        /**
         * Ordiniamo l'array per valore, in modo da poter risolvere i filtri uguali
         * Ordino array per valore cosi da indicare vicino i campi con stesso valore
         */

        tempArray.sort(function (a, b) {
            //console.log("compara "+a.valore + " con " + b.valore + " risultato: " + (a.valore).localeCompare(b.valore))

            return (a.valore.toLowerCase()).localeCompare(b.valore.toLowerCase())
        });

        /**
         * In caso di uno stesso valore su piu campi
         * Unisco i campi con stesso valore ed elimino il secondo
         */
        tempArray.forEach((item, index) => {

            if (tempArray[index + 1] && (item.valore.localeCompare(tempArray[index + 1].valore) == 0)) {
                //console.log("trovato doppio " + item.campo + " - " + tempArray[index+1].campo)
                item.campo = item.campo + "|" + tempArray[index + 1].campo; //genero campo doppio separato da |
                tempArray.splice(index + 1, 1);
            }
        })

        //console.log("nuovo array temparray");
        //console.log(tempArray);
        //Ordinamento per ordine crescente e frequenza decrescente
        tempArray.sort(function (a, b) {
            return (a.order - b.order) + ((b.freq - a.freq) * 0.1);
        });


        //rimuoviamo eventuali filtri generati che già compaiono negli active filter
        this.removeDuplicateFromFilter(tempArray, this.active_filter);

        this.filtri = tempArray.slice(0, limit);

    }

    /**
     * Cerca tra i nuovi filtri generati,
     * se ne è stato generato uno già presente tra quelli selezionati
     */
    removeDuplicateFromFilter(array1, array2) {

        let self = this;

        array2.forEach(function (elem, index) {
            var indexOfElement = array1.findIndex(i => i.valore === elem.valore);
            //console.log("trovato indice di "+ elem.campo + " in " + indexOfElement);
            if (indexOfElement != -1) array1.splice(indexOfElement, 1);
        })

    }




    ionSelected() {
        //console.log("Find Page has been selected");
        this.content.scrollToTop();
    }

    /*
      ionViewDidEnter() {

        this.content.scrollToTop();
    }
    */

    doRefresh(refresher) {
        this.fixSize();
        refresher.complete();
    }

    findHelpfulNumbersBanner() {
        this.mySearchText = "utilities";
        this.myInput = this.mySearchText
        this.startSearch();

    }

}


// WEBPACK FOOTER //
// ./src/pages/find/find.ts